export const PHONE_NUMBER = "+965 22094488"
